import styled from "styled-components";

export const ContentSection = styled("section")`
  position: relative;
  padding: 8rem 0 6rem;

  @media only screen and (max-width: 1024px) {
    padding: 4rem 0 4rem;
  }
`;

export const StyledImage = styled.img`
  position: relative;
  width: 100%;
  max-width: 500px;
  height: auto;
  padding: 4rem 0;
  
  @media (max-width: 768px) {
    position: relative;
    width: 90%;
    max-width: 400px;
    height: auto;
    padding: 2rem 0;
  }
`;

export const VerticalStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1187px) {
    padding-left: 4rem;
  }

  @media (max-width: 767px) {
    padding-left: 0;
  }

`;

export const LeftAlignedContentWrapper = styled.div`
  text-align: left;
  max-width: 420px;
`;

export const ContentHeader = styled("div")`
  font-family: 'Gilroy Light', serif;
  color: #000000;
  text-align: left;
  font-size: 18px;
  max-width: 420px;
  line-height: 1.18;
  margin-bottom: 15px;
`;

export const ContentText = styled("div")`
  font-family: 'Gilroy Light', serif;
  color: #000000;
  text-align: left;
  font-size: 18px;
  max-width: 320px;
  line-height: 1.18;
  margin-bottom: 15px;
`;

export const ContentList = styled("div")`
  font-family: 'Gilroy Bold', serif;
  color: #2159A6;
  text-align: left;
  font-size: 28px;
  max-width: 420px;
  line-height: 1.18;
  margin-bottom: 5px;
`;

export const VerticalLine = styled.div`
  position: absolute;
  left: 54%;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #FFB4AB;
  z-index: 1;

  @media (max-width: 767px) {
    position: relative;
    width: 100%;
    height: 10px;
    left: 0;
    margin-bottom: 1rem;
  }
`;
